// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RightPanel__container-a79926 {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.RightPanel__member-list-container-a42cef {
  flex: 1 1;
  overflow-y: auto;
}

.RightPanel__member-list-container-a42cef::-webkit-scrollbar-track {
  background-color: var(--addition-80);
}

.RightPanel__description-addcaa {
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-subtitle-2);
  color: var(--addition-50);
  opacity: 0.7;
  padding: 11px 16px;
}

.RightPanel__waiting-room-description-bd0463 {
  display: flex;
  padding: 0 16px;
}

.RightPanel__waiting-room-description-text-ea6443 {
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-subtitle-2);
  color: var(--addition-50);
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RightPanel/RightPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EAEA,YAAA;AAAF;;AAGA;EACE,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,4BAAA;EACA,sCAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;AAAF;;AAGA;EACE,4BAAA;EACA,sCAAA;EACA,yBAAA;EACA,YAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n\n  height: 100%;\n}\n\n.member-list-container {\n  flex: 1 1;\n  overflow-y: auto;\n}\n\n.member-list-container::-webkit-scrollbar-track {\n  background-color: var(--addition-80);\n}\n\n.description {\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-subtitle-2);\n  color: var(--addition-50);\n  opacity: 0.7;\n  padding: 11px 16px;\n}\n\n.waiting-room-description {\n  display: flex;\n  padding: 0 16px;\n}\n\n.waiting-room-description-text {\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-subtitle-2);\n  color: var(--addition-50);\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RightPanel__container-a79926`,
	"member-list-container": `RightPanel__member-list-container-a42cef`,
	"memberListContainer": `RightPanel__member-list-container-a42cef`,
	"description": `RightPanel__description-addcaa`,
	"waiting-room-description": `RightPanel__waiting-room-description-bd0463`,
	"waitingRoomDescription": `RightPanel__waiting-room-description-bd0463`,
	"waiting-room-description-text": `RightPanel__waiting-room-description-text-ea6443`,
	"waitingRoomDescriptionText": `RightPanel__waiting-room-description-text-ea6443`
};
module.exports = ___CSS_LOADER_EXPORT___;
